var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('mySwitch',{attrs:{"open-name":"Ok","size":"lg","close-name":"No","color":"blue","value":_vm.toggle,"disabled":"disabled"},on:{"update:value":function($event){_vm.toggle=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7da14aef","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checklist_Componentes/switch.vue
// module id = 2884
// module chunks = 0